import { visitorHeaders } from '@/utils/visitor-ip'

export default function ({ $axios, redirect, app, req }) {
  // Rendering a page, we call the API from our server, so it would otherwise see us as the visitor.
  if (process.server && req) {
    const visitor = visitorHeaders(req)
    $axios.onRequest((config) => {
      // Returning a value here would replace the whole request config, so only mutate.
      Object.assign(config.headers, visitor)
    })
  }
  // The browser uses the published API port; SSR reaches the backend's Docker
  // service. Sanctum's provider generates absolute URLs, so rewrite those too.
  if (process.server && process.env.BACKEND_INTERNAL_URL) {
    const internal = process.env.BACKEND_INTERNAL_URL
    const browserOrigin = new URL(process.env.BACKEND_URL).origin
    $axios.setBaseURL(internal)
    $axios.onRequest(config => {
      if (config.url && config.url.startsWith(browserOrigin + '/')) {
        config.url = internal + config.url.slice(browserOrigin.length)
      }
      if (!config.headers.referer && req) {
        config.headers.referer = 'http://' + req.headers.host + '/'
      }
    })
  }
  $axios.onError(error => {
    const response = error && error.response
    if (response && response.status === 403 && response.data && ['photo_verification_required', 'ip_verification_required'].includes(response.data.code)) {
      // Refreshing the user brings up the required verification modal right away.
      if (process.client && app.$auth) app.$auth.fetchUser().catch(() => {})
      return
    }
    if (error !== undefined && error.response !== undefined && error.response.status === 401) {
      // Auth handles an expired session by clearing the user. Redirecting its
      // initial fetch would also evict guests from public, localized pages.
      const url = error.config && error.config.url
      if (url && new URL(url, 'http://localhost').pathname === '/api/user') return

      redirect(app.localePath('/users'))
    }
  })
}
